import React from 'react'

import HelpText from '@/components/misc/HelpText'
import SelectCompanyIndividuals from '@/components/select/SelectCompanyIndividuals'
import { ReferralIndividual } from '@/types/misc'
import { CompanyProfileItemCompany } from '@/types/responses/companies'

interface Props {
  company: CompanyProfileItemCompany
  referralIndividuals: ReferralIndividual[]
  onSelectReferralIndividuals: (individuals: ReferralIndividual[]) => void
  isDisabled?: boolean
}

const CreateOrUpdateReferralLink: React.FC<Props> = ({
  company,
  referralIndividuals,
  onSelectReferralIndividuals,
  isDisabled,
}) => (
  <>
    <div className="mb-2">
      <p className="text-md mb-0">
        Choose the individuals at {company.presentationName} that you want to
        refer to:
      </p>
    </div>

    <SelectCompanyIndividuals
      company={company}
      selected={referralIndividuals}
      onSelect={onSelectReferralIndividuals}
      additionalParams={{ hasCalendarConnection: true }}
      isDisabled={isDisabled}
    />

    <HelpText>
      Please note: You can only select advisers from {company.presentationName}{' '}
      who have connected their calendars.
    </HelpText>
  </>
)

export default CreateOrUpdateReferralLink
